import { HttpClient ,HttpHeaders} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { User } from 'app/core/user/user.types';
import { Usuario } from 'app/core/user/usuario.types';
import { map, Observable, ReplaySubject, tap } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({providedIn: 'root'})
export class UserService
{
    private _httpClient = inject(HttpClient);
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    private _usuario: ReplaySubject<Usuario> = new ReplaySubject<Usuario>(1);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User)
    {
        // Store the value
        console.log("hola user");``

        this._user.next(value);
    }

    get user$(): Observable<User>
    {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current signed-in user data
     */
   
   /* get(): Observable<User>
    {
       //
        return this._httpClient.get<User>('api/common/user/1234').pipe(
            tap((user) =>
            {
                this._user.next(user);
            }),
        );


    }*/
  
    get(): Observable<User> {
      const url = environment.path + '/usuario/obtenerxid';
    
      const token = localStorage.getItem('accessToken');
      const email = localStorage.getItem('email');
    
      
      console.log('Email:', email);
    
      if (!email) {
        console.error('No se encontró el email en localStorage');
        return null; // Retorna un Observable nulo si no hay email
      }
    
      const body = { email };
    
      const options = {
        headers: new HttpHeaders({
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    
      return this._httpClient.post<any>(url, body, options).pipe(
        tap((data) => {
         // console.log('data.usuario', data.usuario);
    
          if (data && data.id) {
            const userTmp = {
              id: '1',
              name: email,
              avatar: "https://via.placeholder.com/150", // Puedes actualizar con una URL real
              status: 'online',
              email: email,
            };

            let objeto= {
              "nombreCompleto": email,
              "profilepicture": null,
              "theme": null,
              "rolid": null,
              "rolname": null,
              "companyid": null,
              "companyname": null,
              "route": null,
              "statusRoute": null,
              "leadCheked": null,
              "roles": null,
              "envioCorreo": 0,
              "recaptchaValidate": 0,
              "status": 0,
              "TokenAccess": false,
              "password": null
            };

            let lista= [
              {
                "valLogin": null,
                "companyRUC": null,
                "companySecondaryRuc1": null,
                "companySecondaryRuc2": null,
                "rolId": 1,
                "rolName": "Administrador",
                "status": 0,
                "TokenAccess": 0,
                "companyId": 1,
                "companyName": "Infocore",
                "SesionUnica": 0
              }
            ];
    
            localStorage.setItem('userSession', JSON.stringify(objeto));
            localStorage.setItem('userRoleSession', JSON.stringify(lista));
    
            //if (data['lista'].length > 0) {
              //localStorage.setItem('roleSelected', JSON.stringify(data['lista'][0]));
           // }
    
            this._user.next(userTmp); // Emitir el usuario
          } else {
            console.error('data.usuario es null o undefined');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('id');
            this._user.next(null);
          }
        })
      );
    }
    
      

    /**
     * Update the user
     *
     * @param user
     */
    update(user: User): Observable<any>
    {
        
        return this._httpClient.patch<User>('api/common/user', {user}).pipe(
            map((response) =>
            {
                this._user.next(response);
            }),
        );
    }
}
